/**
 * Favorites Section Component for Lobby2.0
 * PERFORMANCE OPTIMIZED: Uses CSS modules for instant view switching
 */

import React from 'react';
import type { ISectionProps } from '../../../../types/models/ISectionProps';
import Section from '../../../../layouts/Section';
import { FAVORITE_SECTION_NAME } from '@repo/common';

const FavoritesSection: React.FC<ISectionProps> = ({ data, isPortrait, isActive = false, lobbyContainerRef }) => {
    return (
        <Section
            key={FAVORITE_SECTION_NAME}
            data={data}
            isActive={isActive}
            isPortrait={isPortrait}
            isFav={true}
            lobbyContainerRef={lobbyContainerRef}
        />
    );
};

export default FavoritesSection;